import { render, staticRenderFns } from "./estimation.vue?vue&type=template&id=ff586068"
import script from "./estimation.ts?vue&type=script&lang=ts&external"
export * from "./estimation.ts?vue&type=script&lang=ts&external"
import style0 from "./estimation.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff586068')) {
      api.createRecord('ff586068', component.options)
    } else {
      api.reload('ff586068', component.options)
    }
    module.hot.accept("./estimation.vue?vue&type=template&id=ff586068", function () {
      api.rerender('ff586068', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/in-year-budget-requests/view-in-year-budget-request/estimation/estimation.vue"
export default component.exports